import http from './httpClient';

class InventoryCategoriesService {
  static async list(businessId) {
    return http.get(`/inventory-categories/${businessId}`);
  }
  static async add(businessId, name) {
    return http.post(`/inventory-categories/${businessId}`, { name });
  }
  static async remove(categoryId) {
    return http.delete(`/inventory-categories/${categoryId}`);
  }
}

export default InventoryCategoriesService;
